var React = require('react');

function Czech (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_3459_4591)","key":0},[React.createElement("rect",{"width":"28","height":"28","rx":"14","fill":"#D7141A","key":0}),React.createElement("g",{"clipPath":"url(#clip1_3459_4591)","key":1},[React.createElement("path",{"d":"M35 0H-7V14H35V0Z","fill":"white","key":0}),React.createElement("path",{"d":"M14 14L-7 0V28L14 14Z","fill":"#11457E","key":1})])]),React.createElement("defs",{"key":1},[React.createElement("clipPath",{"id":"clip0_3459_4591","key":0},React.createElement("rect",{"width":"28","height":"28","rx":"14","fill":"white"})),React.createElement("clipPath",{"id":"clip1_3459_4591","key":1},React.createElement("rect",{"width":"42","height":"28","fill":"white","transform":"translate(-7)"}))])]);
}

Czech.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Czech;

Czech.default = Czech;
